

  import store from '@/store/index';

export const setDocumentTitle = async function () {
  let data= await store.dispatch('configs/setLogo')
  document.title = data.www_title;

  const ua = navigator.userAgent;
  // eslint-disable-next-line
  const regex = /\bMicroMessenger\/([\d\.]+)/;
  if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    const i = document.createElement('iframe');
    // i.src ='https://yl.oss.jdbsk.com'+logo_src;
    // console.log(1234);
    // console.log(logo_src);
    // i.style.display = 'none';
    i.onload = function () {
      setTimeout(function () {
        i.remove();
      }, 9);
    };
    document.body.appendChild(i);
  }
};

export const domTitle = '尚信担保';
